module.exports = __webpack_public_path__ + "img/yoga-guy.8088b34.svg";